import {
	createContext,
	useState,
	useEffect,
	Dispatch,
	SetStateAction,
} from "react";

import socket from "../services/socket";

import { login, logoff } from "../services/auth";

interface AuthContextData {
	signed: boolean;
	user: any;
	signIn(): Promise<boolean>;
	signOut(): void;
	error: string;
	// socket?: Socket;
	setError: Dispatch<SetStateAction<string>>;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC = ({ children }) => {
	const [user, setUser] = useState<any>(null);
	const [error, setError] = useState("");

	useEffect(() => {
		const verify = async () => {
			let user = await localStorage.getItem("@REALIZAR:user");
			const token = await localStorage.getItem("@REALIZAR:user_token");

			if (user && token) {
				user = JSON.parse(user);
				setUser(user);
			}
		};
		verify();
	}, []);

	const signIn = async () => {
		try {
			const response = await login();

			if (response.error) {
				setError(response.error);
				return false;
			}

			const user = response.data.user;

			localStorage.setItem("@REALIZAR:user_token", response.data.token);
			localStorage.setItem("@REALIZAR:user", JSON.stringify(user));

			socket.emit("connected", { id: user.id });

			setUser(user);

			return true;
		} catch (reason) {
			console.log(reason);

			return false;
		}
	};

	const signOut = async () => {
		try {
			socket.emit("user:disconnect", { id: user.id });

			logoff();
			setUser(null);

			localStorage.removeItem("@REALIZAR:user_token");
			localStorage.removeItem("@REALIZAR:user_pass");
			localStorage.removeItem("@REALIZAR:user");
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<AuthContext.Provider
			value={{
				signed: !!user,
				user,
				signIn,
				signOut,
				error,
				setError,
				// socket,
			}}>
			{children}
		</AuthContext.Provider>
	);
};

export default AuthContext;
